import { InjectionToken } from '@angular/core';
import { ContactPerson, Event, Exhibitor, Post, Product } from '@planone/shared/util-interfaces';
import { ImageProviders } from '@planone/shared/util-pipelines';
import { BehaviorSubject } from 'rxjs';

export interface SwiperInteraction {
  interaction_type: 'OPEN' | 'SWIPE_TO' | 'INIT';
  image_resource: string;
  image_provider?: ImageProviders;
  image_description: string;
  image_position: number;
  context: string;
  page_type: string;
  exhibitor?: Exhibitor;
  product?: Product;
  event?: Event;
  post?: Post;
  contactPersonId?: string;
  contact_person?: ContactPerson;
  image_count: number;
}

export interface SwiperInteractionEvent {
  type: 'OPEN' | 'SWIPE_TO' | 'INIT';
  index: number;
}

export const SWIPER_INTERACTION_EMITTER = new InjectionToken<BehaviorSubject<SwiperInteractionEvent>>(
  'SWIPER_INTERACTION_EMITTER'
);
